import { use } from 'react';

import { useTranslation } from 'react-i18next';

import { Card, EmptyState } from '~components';
import OfflineAccessDataGrid from '~features/offlineAccess/offlineAccessDataGrid';

import KeyActionsBar from '../components/keyActionBar';
import KeyContext from '../providers/keyContext';

const KeyOfflineAccessContainer = () => {
	const { t } = useTranslation('entities');
	const keyContext = use(KeyContext);
	const keyId = keyContext.key?.id ?? '0';
	const organisationId = keyContext.overwrittenClientId;
	return (
		<>
			<KeyActionsBar keyId={keyId} organisationId={organisationId} />
			<Card
				title={t('offlineAccess', { ns: 'nav' }) + ' ' + t('key.labels.plural', { ns: 'entities' })}
				sx={{ height: '100%' }}
			>
				{keyId != null && organisationId != null ?
					<OfflineAccessDataGrid
						source={'key'}
						keyId={keyId}
						overwrittenClientId={organisationId}
						showAddOfflineKeyButton={false}
						enableRemoveOfflineKey={false}
					/>
				:	<EmptyState
						icon={'icon/bar-chart-square'}
						title={t('noDataTitle', { ns: 'table' })}
						description={t('noDataDescription', { ns: 'table' })}
					/>
				}
			</Card>
		</>
	);
};

export default KeyOfflineAccessContainer;
